import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    IconButton,
    Tooltip,
    Collapse,
    Button,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch, StatusFilterSelect } from 'common/components';
import { getProjectStatusOptions } from 'common/utils/helpers';

const Filters = ({
    contactId,
    filterData,
    handleClickCreate,
    handleOnChangeSearch,
    handleOnSelectProjectStatus,
    handleOnSelectStatus,
    isArchived,
    selectionModel,
}) => {
    const { t } = useTranslation();
    const [filterIsOpen, setFilterIsOpen] = React.useState(false);
    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    const statusOptions = getProjectStatusOptions();

    return (
        <>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: 1,
                }}
                size={{ lg: isEmpty(selectionModel) ? 12 : 8, xs: 18 }}
            >
                <InputSearch
                    onChange={handleOnChangeSearch}
                    placeholder={t('Search project')}
                    value={filterData?.searchText}
                />
                <Tooltip title={t('Filter', { count: 2 })}>
                    <IconButton onClick={toggleFilter}>
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>
                <Button
                    endIcon={<AddIcon />}
                    sx={{
                        whiteSpace: 'nowrap',
                        display: {
                            xs: 'none',
                            sm: 'none',
                            md: 'none',
                            lg: 'inline-flex',
                        },
                    }}
                    onClick={() => handleClickCreate(contactId)}
                    type="button"
                    visible={!isArchived}
                >{`${t('Create')} ${t('Project')}`}</Button>
            </Box>
            <Collapse in={filterIsOpen} sx={{ width: '100%' }}>
                <Grid container mt={2}>
                    <Grid
                        size={{
                            lg: 5,
                            md: isEmpty(selectionModel) ? 9 : 6,
                            xs: 18,
                        }}
                    >
                        <FormControl fullWidth size="small">
                            <InputLabel>{t('Project status')}</InputLabel>
                            <Select
                                label={t('Project status')}
                                onChange={(e) =>
                                    handleOnSelectProjectStatus(e.target)
                                }
                                value={filterData?.projectStatus}
                                variant="outlined"
                            >
                                {[
                                    {
                                        label: t('All text', {
                                            count: 2,
                                        }),
                                        value: '',
                                    },
                                    ...statusOptions,
                                ].map(({ label, value, disabled }) => (
                                    <MenuItem
                                        disabled={disabled}
                                        key={`status-select-${value}-${label}`}
                                        value={value}
                                    >
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid
                        size={{
                            lg: 3,
                            md: isEmpty(selectionModel) ? 9 : 6,
                            xs: 18,
                        }}
                    >
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={handleOnSelectStatus}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Collapse>
            <Button
                endIcon={<AddIcon />}
                sx={{
                    whiteSpace: 'nowrap',
                    width: '100%',
                    mt: 2,
                    display: {
                        xs: 'inline-flex',
                        sm: 'inline-flex',
                        md: 'inline-flex',
                        lg: 'none',
                    },
                }}
                onClick={() => handleClickCreate(contactId)}
                type="button"
                visible={!isArchived}
            >{`${t('Create')} ${t('Project')}`}</Button>
        </>
    );
};

Filters.propTypes = {
    contactId: PropTypes.string,
    filterData: PropTypes.object,
    handleClickCreate: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectProjectStatus: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
    isArchived: PropTypes.bool,
    selectionModel: PropTypes.array,
};

export default Filters;
